module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
// Activity_Event_LiveshowEvent Widget

(function (fox, $) {
	
	fox.registerWidget('Activity_Event_LiveshowEvent', {

		configure: function () {
			this.registerOptions('', {
				autoRender: true,
				template: 'activity_event_card_liveshow',
				widgets: {
					timer: {
						widget: 'JQTimer',
						'embed.container': '.counter-wrapper',
						autoRender: false,
						counterWrapperId: '.counter',
						// 'handleWom.timerStopHandler': {
						// 	callback: '@parent:checkLiveShows'
						// },
						'handleWom.addedToDom': {
							widget: '@this',
							event: 'addedToDom',
							callback: '@parent:customizeCounter'
						}
					}
				}
			});

			this.callParent('configure', arguments);
		},

		init: function () {
			this.p = this.getParent();
			this.liveshowData = this.p.eventTypedParams;

			this.statusAliases = {
				0: 'scheduled',
				1: 'inProgress',
				2: 'inProgress',
				3: 'finished',
				4: 'error'
			}

			var status = this.liveshowData.status;

			if (new Date(this.liveshowData.startDate) > new Date() && status === 0) {
				this.setOption('scheduled', true);
			}

			this.liveshowData.statusAlias = this.statusAliases[status];
		
			this.callParent('init', arguments);
		},

		addedToDom: function () {
			this.initCounter();
		},

		customizeCounter: function (obj, scope) {
			obj = {
				0: 'days',
				2: 'hrs',
				4: 'mins',
				6: 'secs'
			};

			fox.each(obj, fox.bind(function (val, key) {
				$(this.dom1('.counter')).find('.part' + key).append('<div>' + val + '</div>');
			}, this));
		},

		initCounter: function () {
			if (this.getOption('scheduled')) {
				this.startCounter();
			}
		},

		startCounter: function () {
			this.rwom1('#timer').counterStart(fox.utils.getRemainingTime(this.liveshowData.startDate));
		}

	}, 'Widget');

})(fox, jQuery);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/widget/activity/event/liveshowEvent.js
// module id = 789
// module chunks = 4